
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "RBRHAABOH",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RBRHAABOH.vue